define(function(require, exports, module) {
    var tplModel = require('../model/tplModel/tplModel');
    var price = require('../unit/price/price');
    var lazyload = require('../unit/lazyload/lazyload');
    var tapEvent = require('../unit/tapEvent/tapEvent');
    var Config = require('../Config/Config');
    var tabModel = require('../model/tabModel/tabModel');

    var bottomCatSwiper = {
        loadMoreFlag: new Array(),
        PAGE_SIZE: 20,
        init : function() {
            var self = this;
            
            if ($(".more").length) {

                var columnTabNum = $(".columnTab dl dd").length;
                var previewCnt = 1;
                if (columnTabNum <= 4) {
                    previewCnt = columnTabNum;
                } else {
                    previewCnt = 4.5;
                }

                var bottomCat = new Swiper(".columnTab", {
                    slidesPerView: previewCnt,
                    freeMode: true,
                    lazyLoading: true,
                    freeModeSticky: false
                });

                //一级分类tab标签点击事件
                tabModel.tapEvent(".more .tabs dd", "", "", bottomCatSwiper.firstClassTapEvt, bottomCat);
                //二级分类tab标签点击事件
                tabModel.tapEvent(".more .tabs .second-cat .name", "", "", bottomCatSwiper.secondClassTapEvt, bottomCat);

                //when loading page for the first time, judge if the data is from config or search
                //goods are begin with tag a, so we select by children('a')
                var node = $(".more .tabs").find('[cnt-idx="1"] .curr');
                node.data('pageNum', 1);
                if($('.more .tabs .goods').children('a').length > 0 ) {
                    node.data('isFromConfig', true);
                } else {
                    node.data('isFromConfig', false);
                    var evt = {type: 'touchend'};
                    bottomCatSwiper.searchGoods(node.attr('classid'), node.html(), 1, node, evt, node.attr('categoryid'));
                }

                bottomCatSwiper.initScrollLoading();

                jQuery(document).on('scroll', function() {
                    if($(".more .tabs").length) {
                        bottomCatSwiper.firstCatToTopOrNot();
                    }
                });
            }
        },
        firstClassTapEvt: function(e, _this, self, selfObj) {
            if(self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {
            } else {
                //设置一级分类背景色
                _this.siblings().removeClass('curr');
                if(!_this.hasClass('curr')) {
                    _this.addClass('curr');
                }

                //找到它下面的对应节点
                var tabIndex = _this.attr('tab-idx');
                var node = $(".more .tabs").find('[cnt-idx="' + tabIndex + '"]');
                node.siblings('.tabCnt').not('.hide').addClass('hide');

                //显示二级标签，若一级分类下面只有一个二级分类，则不显示此二级分类。
                if(node.children().children().length > 1) {
                    node.removeClass('hide');
                }

                //将页面滚动到tab顶部
                bottomCatSwiper.scrollToTabTop(_this);

                self.setPosition(_this, self, selfObj);

                //Trigger tap envet
                bottomCatSwiper.secondClassTapEvt(e, node.children().children().first(), self, selfObj);
            }
        },

        secondClassTapEvt: function(e, _this, self, selfObj) {
            if(self.f.directionY == "top" || self.f.directionY == "bottom" || self.f.directionX == "right" || self.f.directionX == "left") {
            } else {
                _this.addClass('curr').removeAttr('pageNum').siblings().removeClass('curr').css('color','');
                bottomCatSwiper.getGoodsByCatIdorSearch(_this, e);
            }
        },

        getGoodsByCatIdorSearch: function(node, evt) {
            var catId = node.attr('categoryid');
            var pageNum = 1;
            var classid = node.attr('classid');
            var catName = node.html();

            if(evt.type === 'touchend') {
                bottomCatSwiper.loadMoreFlag = new Array();
                bottomCatSwiper.loadMoreFlag[catId] = new Array();
                node.data('noMore', false);
                pageNum = 1;
                bottomCatSwiper.showLoading();
                //如果是用户点击，记录请求时间到节点，以便数据返回时判断是否是最新数据。
                //如果不是最新数据，则不渲染
                bottomCatSwiper.recordReqTime(node);
            } else {
                pageNum = node.data('pageNum') >= 1 ? node.data('pageNum')+1 : 1;
            }

            //var loadMoreFlag = bottomCatSwiper.loadMoreFlag;
            if(bottomCatSwiper.loadMoreFlag[catId] === undefined) {
                bottomCatSwiper.loadMoreFlag[catId] = new Array();
            }

            // we don't know the data is from our backend config or not
            if(node.data('isFromConfig') === undefined && !bottomCatSwiper.loadMoreFlag[catId][pageNum]) {
                //console.log('not sure where to get data.. ');

                bottomCatSwiper.loadMoreFlag[catId][pageNum] = true;

                bottomCatSwiper.getGoodsFromConfig(catId, pageNum, bottomCatSwiper.PAGE_SIZE, node, evt)

            } else if(node.data('isFromConfig')) {
                if(!bottomCatSwiper.loadMoreFlag[catId][pageNum] && !node.data('noMore')) {
                    //console.log('sure it is from bk, retriving data , pageNum: ', pageNum);
                    bottomCatSwiper.loadMoreFlag[catId][pageNum] = true;
                    bottomCatSwiper.getGoodsFromConfig(catId, pageNum, bottomCatSwiper.PAGE_SIZE, node, evt)
                }
            } else if(!node.data('isFromConfig') && !node.data('noMore')) {
                //console.log('sure it is from search ....');
                if(!bottomCatSwiper.loadMoreFlag[catId][pageNum] && !node.data('noMore')) {
                    bottomCatSwiper.loadMoreFlag[catId][pageNum] = true;
                    bottomCatSwiper.searchGoods(classid, catName, pageNum, node, evt, catId);
                    node.data('isFromConfig', false);
                }
            }

        },

        getGoodsFromConfig: function(catId, pageNum, pageSize, node, evt) {
            //console.log('get goods from config');
            
            var params = {
                cateId: catId,
                pageNo: pageNum,
                pageSize: pageSize,
                sign: $("#sign").val()
            };

            $.ajax({
                url: Config.serviceInterface.getZyLoadMore,
                data: params,
                method: "get",
                dataType: 'json',
            }).done(function(ret) {
                if(ret.success && ret.result && ret.result.selfChannelCategorySpecialGoods.length > 0) {
                    data = ret.result.selfChannelCategorySpecialGoods;
                    bottomCatSwiper.renderData(data, evt.type, node);
                    node.data('isFromConfig', true);
                    node.data('pageNum', pageNum);

                    if(data.length < pageSize) {
                        bottomCatSwiper.loadMoreFlag[catId][pageNum] = false;
                        node.data('noMore', true);
                    }
                } else if(ret.result && ret.result.selfChannelCategorySpecialGoods.length === 0 && !node.data('isFromConfig')) {
                    //如果从后台加载过来没有数据，再从搜索接口加载.
                    //If no data configered from our backend, then load data from search api
                    //console.log('there is not configering data, retriving data from search apis');
                    bottomCatSwiper.searchGoods(node.attr('classid'), node.html(), pageNum, node, evt, catId);
                    node.data('isFromConfig', false);
                } else if((node.data('pageNum') == 1 && pageNum != 2) || !ret.success) {
                    //当前页数是第一页，且加载的页数是第二页的时候，没有出来出具，也不渲染成空的
                    bottomCatSwiper.showNomoreTip();
                }
                bottomCatSwiper.firstCatToTopOrNot();
            });
        },

        //classid 为搜索用到的品类id
        //catId 仅仅用于记录当前页是否被请求
        searchGoods: function(classid, catName, pageNum, node, evt, catId) {
            var params = {
                promotion: "",
                delivery: "",
                ev: "",
                sort: "sort_default_desc",
                page: pageNum,
                self: 1
            };

            if(classid != null && classid.length) {
                params.cat = classid;
            } else {
                params.searchkey = catName;
            }

            //console.log('ajax call begin');
            if(pageNum === 1) {
                bottomCatSwiper.showLoading();
            }

            $.ajax({
                url: Config.serviceInterface.searchGoodsByCat,
                method: "get",
                dataType: 'json',
                data: params
            }).done(function(data) {
                if(data) {
                    var items = bottomCatSwiper.convertToItemsArray(data);
                    //if(items.length > 0 || pageNum === 1) {
                        node.data('pageNum', pageNum);
                    //}
                    bottomCatSwiper.renderData(items, evt.type, node);
                }
                if(data && data.items.length < bottomCatSwiper.PAGE_SIZE) {
                    bottomCatSwiper.loadMoreFlag[catId][pageNum] = false;
                    node.data('noMore', true);
                }
                bottomCatSwiper.firstCatToTopOrNot();
            });
        },

        initScrollLoading: function() {
            $(window).scroll(function(evt) {
                var scrollToLoadHeight = ($(document).height() - 50 * parseInt($("html").css("font-size")));
                if($(window).scrollTop() + $(window).height() > scrollToLoadHeight) {
                    var cntIdx = $('.more .tabs .swiper-wrapper dd.curr').attr('tab-idx');
                    var currCatNode = bottomCatSwiper.getCurrSecondCatNode(cntIdx);
                    bottomCatSwiper.getGoodsByCatIdorSearch($(currCatNode), evt);
                }
            });
        },

        renderData: function(data, type, node) {
            var goodsDiv = $('.more .tabs .goods');
            var pageNum = node.data('pageNum');
            var tpl = require("../template/gatherLoadMore");
            var html = tplModel.render({goods: data, pageNum: pageNum}, tpl);
            if(type === 'touchend') {
                //如果为点击事件，则肯定请求的是第一页
                //有数据回来的时候，请求时间和节点记录的时间一致才渲染
                if(node.data('reqTime') === goodsDiv.data('reqTime')) {
                    goodsDiv.html(html);
                    if(data.length === 0 && pageNum == 1) {
                        bottomCatSwiper.showNomoreTip();    
                    }
                } else {
                    
                }
            } else if(type === 'scroll') {
                if(node.data('reqTime') === goodsDiv.data('reqTime')) {
                    //如果是滚动事件，有数据回来的且为第一页，提示没有跟多，否则渲染数据。
                    if(data.length === 0 && pageNum == 1) {
                        bottomCatSwiper.showNomoreTip();
                    } else {
                        goodsDiv.append(html);
                    }
                } else {
                    //如果是用户的滚动事件, 发送请求的时间和商品节点上的时间不一样，
                    //而且又是第一页的时候，直接丢弃结果不渲染
                    if(pageNum == 1) {

                    } else {
                        goodsDiv.append(html);
                    }
                }
            }

            price.fn.init('pcpPrice');
            lazyload.fn.init();
            tapEvent.tapItem();
        },

        convertToItemsArray: function(data) {
            if(!data || !data.items || data.items.length < 0) {
                return [];
            };

            var ret = data.items.map(function(item) {
                return {
                    itemText: item.skuName,
                    skuImg: item.skuImage,
                    skuText: item.skuId
                }
            });
            //console.log(ret);
            return ret;
        },

        scrollToTabTop: function(node, prevHeight) {
            
            if ($(".tabs").hasClass('fixed')) {

                secondcatNode = bottomCatSwiper.getFirstChildByCntIdx(node.attr('tab-idx')).parent().parent();

                //如果一级分类下面的二级分类是hide了的，先将它取消掉，以免影响高度
                var isSecondcatHide = secondcatNode.hasClass('hide');
                if(isSecondcatHide) {
                    secondcatNode.removeClass('hide').removeClass('hide');
                }
                var thisHeight = node.height();
                var idx = node.attr('tab-idx');
                var distanceTop = $("div[cnt-idx='" + idx + "']").offset().top;
                $("body").scrollTop(distanceTop - thisHeight);
                if(isSecondcatHide) {
                    secondcatNode.addClass('hide');
                }
                $(".more .tabs").removeClass("fixed");
            }

        },

        getFirstChildByCntIdx: function (idx) {
            var node = $("div[cnt-idx='" + idx + "']");
            return node.children().children().first();
        },

        getCurrSecondCatNode: function(idx) {
            var node = $("div[cnt-idx='" + idx + "']");
            return node.children().children('.curr');
        },

        showLoading: function() {
            $('.more .goods').children('a').remove();
            var maskNode = $('.more .tabs .goods .mask');
            var loadingImg = maskNode.children('img');
            var tipNode = maskNode.children('.nomore-tip');

            if(maskNode.hasClass('hide')) {
                maskNode.removeClass('hide');
            }

            if(loadingImg.hasClass('hide')) {
                loadingImg.removeClass('hide');
            }
            
            if(!tipNode.hasClass('hide')) {
                tipNode.addClass('hide');
            }
        },

        hideLoading: function() {
            var maskNode = $('.more .tabs .goods .mask');
            if(!maskNode.hasClass('hide')) {
                maskNode.addClass('hide');
            }
        },

        showNomoreTip: function() {
            $('.more .goods').children('a').remove();
            var maskNode = $('.more .tabs .goods .mask');
            var loadingImg = maskNode.children('img');
            var tipNode = maskNode.children('.nomore-tip');

            if(maskNode.hasClass('hide')) {
                maskNode.removeClass('hide');
            }

            if(!loadingImg.hasClass('hide')) {
                loadingImg.addClass('hide');
            }
            
            if(tipNode.hasClass('hide')) {
                tipNode.removeClass('hide');
            }

        },

        hideNomoreTip: function() {
            bottomCatSwiper.hideLoading();
        },

        recordReqTime: function(node) {
            var goodDiv = $('.goods');
            var timeStamp = new Date().getTime();
            goodDiv.data('reqTime', timeStamp);
            node.data('reqTime', timeStamp);
        },

        firstCatToTopOrNot: function() {
            if ($("body").scrollTop() - $(".more .tabs").offset().top >= 0) {
                if(!$(".more .tabs").hasClass("fixed")) {
                    $(".more .tabs").addClass("fixed");
                }
            } else {
                $(".more .tabs").removeClass("fixed");
            }
        }
    }

    module.exports = bottomCatSwiper;
});



// WEBPACK FOOTER //
// ./src/js/module/selfChannelBottomCatSwiper.js